import { Input } from '@estac1/ui';
import { Search } from 'lucide-react';
import { SearchResults } from './global-search/search-results.js';
import { useGlobalSearch } from './global-search/use-global-search.js';

export const GlobalSearch = () => {
  const {
    q,
    setQ,
    setOpen,
    containerRef,
    inputRef,
    debouncedQ,
    search,
    close,
    showDropdown,
    totalResults,
  } = useGlobalSearch();

  return (
    <div ref={containerRef} className="relative min-w-0 w-full max-w-xl">
      <div className="relative">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-fg" />
        <Input
          ref={inputRef}
          placeholder="Buscar dono, estacionamento ou operador"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onFocus={() => setOpen(true)}
          className="pl-9 sm:pr-14"
          aria-label="Busca global"
        />
        <kbd className="pointer-events-none absolute right-2 top-1/2 hidden -translate-y-1/2 rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-[10px] text-muted-fg sm:inline-block">
          ⌘K
        </kbd>
      </div>

      {showDropdown && (
        <SearchResults
          search={search}
          debouncedQ={debouncedQ}
          totalResults={totalResults}
          onClose={close}
        />
      )}
    </div>
  );
};
